import { Alert, Card, PageHeader, PageLayout, Section } from '../components';
import { useI18n } from '../i18n';

/**
 * Statistik - in der Navigation vorhanden, inhaltlich noch nicht.
 *
 * Bewusst eine eigene Seite statt eines toten Links: wer hierher klickt,
 * erfährt in einem Satz, was kommt und dass in der Zwischenzeit nichts
 * verlorengeht.
 */
export function StatisticsPage(): JSX.Element {
  const { t } = useI18n();

  return (
    <PageLayout width="mittel">
      <PageHeader title={t('nav.statistics')} />
      <Card>
        <Section title={t('soon.title')}>
          <Alert tone="info">{t('soon.statistics')}</Alert>
          <p className="lead">{t('soon.hint')}</p>
        </Section>
      </Card>
    </PageLayout>
  );
}
